import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateStockError } from "@/core/common/types";
import {
  GET_PRODUCT_ADJUSTMENTS_FETCH_KEY,
  ProductAdjustment,
} from "@/shared/core-product-adjustments";

export const toggleEnabledProductAdjustment = async (
  id: string,
  enabled: boolean,
): Promise<ProductAdjustment> => {
  const response = await fetcher.patch(
    `${API.GESLUB}/product-adjustments/${id}/toggle`,
    { enabled },
  );
  return response.data;
};

export const useToggleEnabledProductAdjustment = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    ProductAdjustment,
    UpdateStockError,
    { id: string; enabled: boolean }
  >({
    mutationFn: ({ id, enabled }) =>
      toggleEnabledProductAdjustment(id, enabled),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_PRODUCT_ADJUSTMENTS_FETCH_KEY],
      });
    },
  });
  return {
    mutate: mutation.mutate,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isPending: mutation.isPending,
    error: mutation.error,
  };
};
